//export const http = "http://localhost:8080";
export const http = "https://attendance.bakerindustries.io";

//export const front = "http://localhost:3001";
//export const front = "139.59.162.67;
